import { IApiSuccessWrapper } from '$/types'
import { apiSlice } from 'app/services/api'
import { ISavedState } from 'features/RiskManagement/Assessments'

export const qraSavedStatesApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ['QRASavedState']
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getQRASavedStates: build.query<ISavedState[], void>({
        query: () => '/qra/savedstates',
        transformResponse: (res: IApiSuccessWrapper) => {
          return res.result as ISavedState[]
        },
        providesTags: (res) => {
          const tags = [{ type: 'QRASavedState' as const, id: 'LIST' }]

          if (res != null) {
            tags.push(
              ...res.map((state) => ({
                type: 'QRASavedState' as const,
                id: state.id.toString()
              }))
            )
          }

          return tags
        }
      }),
      getQRASavedState: build.query<ISavedState, string>({
        query: (id) => `/qra/savedstates/${id}`,
        transformResponse: (res: IApiSuccessWrapper) => {
          return res.result as ISavedState
        },
        providesTags: (_res, _err, id) => [{ type: 'QRASavedState', id }]
      }),
      addQRASavedState: build.mutation<ISavedState, Partial<ISavedState>>({
        query: (state) => ({
          url: '/qra/savedstates',
          method: 'POST',
          body: state
        }),
        transformResponse: (res: IApiSuccessWrapper) => {
          return res.result as ISavedState
        },
        invalidatesTags: [{ type: 'QRASavedState', id: 'LIST' }]
      }),
      updateQRASavedState: build.mutation<ISavedState, Partial<ISavedState>>({
        query: (state) => ({
          url: `/qra/savedstates/${state.id as unknown as string}`,
          method: 'PUT',
          body: state
        }),
        transformResponse: (res: IApiSuccessWrapper) => {
          return res.result as ISavedState
        },
        invalidatesTags: (_res, _err, state) => [
          { type: 'QRASavedState', id: 'LIST' },
          { type: 'QRASavedState', id: state.id }
        ]
      })
    })
  })

export const {
  useGetQRASavedStateQuery,
  useGetQRASavedStatesQuery,
  useAddQRASavedStateMutation,
  useUpdateQRASavedStateMutation
} = qraSavedStatesApi
